<div class="dashboard-container">
  <!-- Sidebar Navigation -->
  <app-dashboard-nav></app-dashboard-nav>
  
  <!-- Main Content Area -->
  <main class="dashboard-main">
    <!-- Top Header -->
    <header class="dashboard-header">
      <img [src]="getHeaderLogo()" alt="" class="header-logo" (error)="useCompanyLogo($event)">
      <div class="header-left">
        <h1>{{ getPageTitle() }}</h1>
        <p class="welcome-text">
          {{ getWelcomeMessage() }}
          <span *ngIf="getOrganisationName()" class="org-text">
            • {{ getOrganisationName() }}
          </span>
        </p>
      </div>
      <div class="header-right">
        <div class="date-display">
          {{ currentDate | date:'EEEE, MMMM d, y' }}
        </div>
      </div>
    </header>

    <!-- Stats Overview -->
    <section class="stats-section">
      <div class="availability-message" role="status" *ngIf="availabilityMessage">{{ availabilityMessage }}</div>
      <app-dashboard-stats [userRole]="getCurrentUserRole()" [operatorBookingEnabled]="operatorBookingEnabled"></app-dashboard-stats>
    </section>

    <!-- Quick Actions for Operators -->
    <section class="quick-actions" *ngIf="isOperator">
      <h2>Quick Actions</h2>
      <div class="actions-grid">
        <a routerLink="/dashboard/trips" class="action-card">
          <i class="material-icons">add_circle</i>
          <span>Schedule Trip</span>
        </a>
        <a routerLink="/dashboard/vehicles" class="action-card">
          <i class="material-icons">directions_car</i>
          <span>Add Vehicle</span>
        </a>
        <a routerLink="/dashboard/routes" class="action-card">
          <i class="material-icons">route</i>
          <span>Create Route</span>
        </a>
        <a *ngIf="operatorBookingEnabled" routerLink="/dashboard/bookings" class="action-card">
          <i class="material-icons">book_online</i>
          <span>View Bookings</span>
        </a>
      </div>
    </section>

    <!-- Router Outlet for Child Components -->
    <div class="content-area">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
